import { usePintMaster, createControlField } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import styled from 'styled-components';
import * as ContentGenres from '@api/content-genres';
import { useRequest } from '@lib/common';
import React, { useEffect, useState } from 'react';
import { map } from 'rxjs/operators';
const AutoCompleteGenere = ({ value, onChange }) => {
  const { loading, master: genres } = usePintMaster('genres');
  // const {loadingGenres, : deliGenres} = const { loading: contentLoading, result: content } = useRequest(
  //   () => contentService.get(id),
  //   [id]
  // );

  const { loading: logsLoading, result: genresMaster } = useRequest(
    () => ContentGenres.get(),
    []
  );

  // console.log({"viraj_value":value})
  // console.log({"viraj_genres":genresMaster})

  const [open, setOpen] = React.useState(false);
  return (
    <GenreStypes>
      <Autocomplete
        multiple
        size="small"
        fullWidth
        filterSelectedOptions
        value={value}
        onChange={(evt, v) => onChange && onChange(v)}
        loading={loading}
        disabled={loading}
        options={genresMaster?.data || []}
        getOptionLabel={value => value.name}
        // getOptionSelected={(option, value) => {
        //   console.log({"viraj_opt": option});
        //   console.log({"viraj_val": value});
        //   return option.id === value.id
        // }}
        renderInput={props => (
          <TextField
            helperText="Select all the genres relevant to this content."
            label={loading ? 'Genres (Loading...)' : 'Genres'}
            placeholder={loading ? 'Genres (Loading...)' : 'Genres'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
    </GenreStypes>
  );
};

const GenreStypes = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const GenresField = createControlField(AutoCompleteGenere, []);
